<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 15 15"
    fill="none"
    class="icon-forfait">
    <path
      class="icon-forfait__path"
      d="M11.3718 8.80026C11.1932 8.77168 10.5074 8.57168 10.3289 8.4931L8.85026 13.1218L6.64305 12.3146L8.21453 8.1931L6.03589 5.71445L7.85737 4.67156C8.17881 5.47873 8.69311 6.15732 9.3717 6.71448C10.0503 7.27164 10.8289 7.62165 11.7003 7.75737L12.5004 5.3073L11.4718 4.97157L11.1003 6.11446C10.6289 5.91446 10.2146 5.61445 9.85743 5.22872C9.50028 4.83586 9.24313 4.3787 9.08598 3.8644L8.85026 3.09295C8.76454 2.80722 8.60025 2.57865 8.36453 2.40721C8.12881 2.24292 7.85737 2.14292 7.59308 2.12149C7.3145 2.10006 7.04306 2.14292 6.78591 2.29292L4.28584 3.73582C4.02155 3.88583 3.82868 4.10012 3.70725 4.37156C3.57153 4.64299 3.54296 4.91443 3.57153 5.20729C3.6001 5.50016 3.75725 5.75731 3.95726 5.97875L6.50733 8.62882L5.30015 11.8146L0.335724 10.036L0 11.0432L10.0289 14.7004C11.022 15.0467 12.095 15.0939 13.1147 14.8361C13.5361 14.7219 13.929 14.5647 14.2861 14.3647L13.479 13.5718C12.9432 13.8075 12.3861 13.929 11.8075 13.929C11.336 13.929 10.8646 13.8504 10.3932 13.6933L9.85743 13.4932L11.3718 8.80026ZM12.1432 1.42861C12.1432 2.22149 11.5075 2.85723 10.7146 2.85723C9.92172 2.85723 9.28598 2.22149 9.28598 1.42861C9.28598 0.635733 9.92886 0 10.7146 0C11.5003 0 12.1432 0.642876 12.1432 1.42861Z"
      :fill="color" />
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: Number,
      default: 15,
    },
    color: {
      type: String,
      default: '#212444',
    },
  });
</script>

<style lang="scss" scoped>
  .icon-forfait {
    .icon-forfait__path {
      fill: currentColor;
    }
  }
</style>
